import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark, oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { useTheme } from '../theme/ThemeContext';

const CodeBlock = ({ language, value }) => {
    const { theme } = useTheme();
    const [copied, setCopied] = React.useState(false);

    const onCopy = async () => {
        try {
            await navigator.clipboard.writeText(value || '');
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch (_) {
            /* ignore */
        }
    };

    return (
        <div className="my-3 overflow-hidden rounded-xl border border-black/10 dark:border-white/10">
            <div className="flex items-center justify-between bg-black/80 px-3 py-1.5 text-xs text-white">
                <span>{language || 'code'}</span>
                <button type="button" onClick={onCopy} className="opacity-80 hover:opacity-100">
                    {copied ? 'Скопировано' : 'Копировать'}
                </button>
            </div>
            <SyntaxHighlighter
                language={language || 'text'}
                style={theme === 'dark' ? oneDark : oneLight}
                customStyle={{ margin: 0, borderRadius: 0, fontSize: 13 }}
            >
                {value || ''}
            </SyntaxHighlighter>
        </div>
    );
};

export default CodeBlock;
